<template>
  <div class="container">

    <div class="row justify-content-center">
      <div class="col-lg-8 col-md-12">
        <h1>{{ title }}</h1>
        <h2>{{ subtitle }}</h2>
        <p>Start your boilerplate search using either the text input or boilerplate categories</p>
        <!-- Boilerplater search with text input, tags and results -->
        <boilerplatesearch></boilerplatesearch>

        
      </div>
    
    </div>
  </div>
</template>

<script>
import boilerplateitem from '@/components/boilerplate-item'
import boilerplatesearch from '@/components/boilerplate-search'
import boilerplate_data from '../boilerplate_data.json'

import axios from 'axios'

export default {
  name: 'hello',
  components: { boilerplateitem, boilerplatesearch },
  data () {
    return {
      title: 'Boilerplater',
      subtitle: 'The boilerplate search engine',
      githubData: null
    }
  },
  created(){
    this.githubData = boilerplate_data.items
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $gutter:          1.25rem;
  $gutter-half:     $gutter / 2;

  h1, h2, h3, h4, h5, h6, 
  .h1, .h2, .h3, .h4, .h5, .h6 {
    margin-bottom: $gutter;
  }

  p {
      font-size: 1.15rem;
  }

  li {
    margin: $gutter-half;
  }

  a {
    color: #42b983;
  }
</style>




// WEBPACK FOOTER //
// boilerplate-index.vue?9f45e880